// ── the four ────────────────────────────────────────────────────────────────
// Names, roles, crafts and lines carried VERBATIM from the team board (Figma
// 2299:528) by way of the investor deck, which is where this data has lived
// since it was written. Nothing here is paraphrased and nothing is inferred:
// every `line` is that person's own sentence about themselves, and the deck and
// the public team page now read the same array rather than two copies that can
// drift apart.
//
// ⚠️ DO NOT ADD BIOGRAPHY THAT IS NOT ALREADY WRITTEN DOWN. Prior companies,
// education, locations — none of it exists in this repo, and a team page is not
// the place to guess about real people. If a founder wants more said, they say
// it and it lands here.

export interface Founder {
  name: string
  role: string
  /** the craft, in three words */
  craft: string
  /** their own line about themselves */
  line: string
  photo: string
  /** their own door — a team page is read by people who will look them up. */
  linkedin: string
}

export const FOUNDERS: Founder[] = [
  {
    name: 'sahil verma',
    role: 'ceo',
    craft: 'vision. design. product.',
    line: 'auteurpreneur. lives in the future. viciously optimistic. obsessive worldbuilder.',
    photo: '/investors/founders/sahil.jpg',
    linkedin: 'https://www.linkedin.com/in/jonnaissance/',
  },
  {
    name: 'nischay chib',
    role: 'cfo · cso',
    craft: 'finance. strategy. go-to-market.',
    line: 'sets the priorities and funds them. disciplined with capital, decisive on direction, relentless in the room.',
    photo: '/investors/founders/nischay.jpg',
    linkedin: 'https://www.linkedin.com/in/nischaychib/',
  },
  {
    name: 'kanav taneja',
    role: 'coo',
    craft: 'operations. systems. spirit.',
    line: 'keeps the ship afloat. ambitiously empathetic. team & personal growth evangelist.',
    photo: '/investors/founders/kanav.jpg',
    linkedin: 'https://www.linkedin.com/in/kanav-taneja-kt-93a224212/',
  },
  {
    name: 'shaurya dhand',
    role: 'cmo',
    craft: 'marketing. partnerships. growth.',
    line: 'lives with the customer, listener, patience, conviction. $10m in combined sales.',
    photo: '/investors/founders/shaurya.jpg',
    linkedin: 'https://www.linkedin.com/in/shaurya-dhand-27919a191/',
  },
]

/** what the team calls itself — the team board's own words. */
export const TEAM_NAME = 'the inners'
